import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RefundPolicyLayer from "../components/RefundPolicyLayer";


const RefundPolicyPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Privacy Policy" />


        {/* TermsConditionLayer */}
        <RefundPolicyLayer />

      </MasterLayout>

    </>
  );
};

export default RefundPolicyPage; 
